
import React from "react";
import Form from "react-bootstrap/Form";
import { useSelector } from "react-redux";

function RatesByAreaDropDown(props) {
  const { options, handleProServiceArray, subOptionData } = props;

  const { selectedProfServiceArray } = useSelector((state) => state.createOrderSlice)

  let value = selectedProfServiceArray?.filter(item => subOptionData?._id === item?.serviceId)[0]?.priceDetails?.range
  return (
    <React.Fragment>


      <Form.Select value={value ?? ''} className="NoDefault" aria-label="Default select example" onChange={(e) => handleProServiceArray(options?.filter(item => item?.range === e.target.value)[0], subOptionData)}>
        <option>Select size of property</option>
        {options.map((item) => {
          return <option value={item?.range}>{item?.range} Sqft</option>;
        })}
      </Form.Select>
    </React.Fragment>
  );
}

export default RatesByAreaDropDown;